import { message } from 'antd';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';

//获取该Section的数据
export async function getSectionData({ component }) {
  let datasourceUrl = component.props.viewConfig.groupList[0].datasourceUrl;

  //datasourceUrl 不为null时调用 datasourceUrl
  //否则就用id获取该Section指定的数据
  let url = datasourceUrl !== null ? datasourceUrl : component.props.areaName + '/' + component.props.section.name + '/' + component.props.objId

  httpClient
    .get(url)
    .then(({ data }) => {
      // console.log(component.props.areaName + '/' + component.props.section.name + '/' + component.props.objId + ' 指定数据', data);
      if (data.result) {
        component.setState({ data: data.data });
        if (component.props.section.name === 'Job') {
          component.props.pageComponent.setState({ jobData: data.data });
          component.props.pageComponent.jobNavigation.current?.setState({ jobData: data.data });
        }
        let sectionData = component.props.pageComponent.state.sectionData;
        sectionData[component.props.section.name] = data.data;
        component.props.pageComponent.setState({ sectionData });
      } else {
        globalFunction.handleResultError(data, component.props.pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, component.props.pageComponent);
    });
}

//获取该Section的数据列表
export async function getSectionDataList({ component, current, pageSize }) {
  let pageable = component.props.viewConfig.groupList[0].pageable;
  let datasourceUrl = component.props.viewConfig.groupList[0].datasourceUrl;

  //datasourceUrl 不为null时调用 datasourceUrl
  //否则看是否要分页，如果分页就走该Section分页接口，否则就走获取该Section全部列表接口
  let searchParameter = '';
  if (component.props.searchParameter != undefined) {
    for (let key in component.props.searchParameter) {
      searchParameter += '&' + key + '=' + globalFunction.nullToEmpty(component.props.searchParameter[key]);
    }
  }
  let url = datasourceUrl !== null ? pageable ? datasourceUrl + '?current=' + current + '&pageSize=' + pageSize + searchParameter : datasourceUrl + '?current=1' + searchParameter : pageable ?
    component.props.areaName + '/' + component.props.section.name + '/GetPaging?current=' + current + '&pageSize=' + pageSize + searchParameter :
    component.props.areaName + '/' + component.props.section.name + '/GetList?current=1' + searchParameter;

  httpClient
    .get(url)
    .then(({ data }) => {
      // console.log(component.props.areaName + '/' + component.props.section.name + ' 列表数据', data);
      //运行预先配置的处理data函数
      operationalFunction({ functionName: component.props.viewConfig.onLoadData, sectionName: component.props.section.name, parameter: data.data, sectionComponent: component, pageComponent: component.props.pageComponent });

      if (data.result && component !== null) {
        component.setState({
          data: []
        });
        component.setState({
          data: pageable ? data.data.records : data.data,
          pagination: pageable ? {
            ...component.state.pagination,
            current: current,
            pageSize: pageSize,
            total: data.data.total
          } : false,
          loaded: true
        });
        if (data.data.length > 0) {
          component.props.sectionComponent.setState({ showBottomButton: true });
        } else {
          component.props.sectionComponent.setState({ showBottomButton: false });
        }
        if (component.props.section.name == 'Property') {
          component.props.pageComponent.setState({ jobData: data.data[0] });
          if (component.props.pageComponent.jobNavigation.current != null) {
            component.props.pageComponent.jobNavigation.current?.setState({ jobData: data.data[0] });
          }
        }
        let sectionData = component.props.pageComponent.state.sectionData;
        sectionData[component.props.section.name] = pageable ? data.data.records : data.data;
        component.props.pageComponent.setState({ sectionData });
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, component.props.pageComponent);
    });
}

//获取该Section, 以Group分组的数据列表
export async function getSectionGroupDataList({ component, current, pageSize }) {
  let datasourceUrl = component.props.viewConfig.groupList[0].datasourceUrl;

  //datasourceUrl 不为null时调用 datasourceUrl
  let searchParameter = '';
  if (component.props.searchParameter != undefined) {
    for (let key in component.props.searchParameter) {
      searchParameter += '&' + key + '=' + globalFunction.nullToEmpty(component.props.searchParameter[key]);
    }
  }
  let url = datasourceUrl !== null ? datasourceUrl + '?current=1' + searchParameter :
    component.props.areaName + '/' + component.props.section.name + '/GetGroupList?current=1' + searchParameter;
  httpClient
    .get(url)
    .then(({ data }) => {
      // console.log(component.props.areaName + '/' + component.props.section.name + ' Group列表数据', data);
      //运行预先配置的处理data函数
      operationalFunction({ functionName: component.props.viewConfig.onLoadData, sectionName: component.props.section.name, parameter: data.data, sectionComponent: component, pageComponent: component.props.pageComponent });

      if (data.result && component !== null) {
        component.setState({
          data: []
        });
        component.setState({
          data: data.data,
          pagination: false,
          loaded: true
        });
        if (data.data.length > 0) {
          component.props.sectionComponent.setState({ showBottomButton: true });
        } else {
          component.props.sectionComponent.setState({ showBottomButton: false });
        }
        let sectionData = component.props.pageComponent.state.sectionData;
        sectionData[component.props.section.name] = data.data;
        component.props.pageComponent.setState({ sectionData });
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, component.props.pageComponent);
    });
}

//获取该Section, 以Folder分组的数据列表
export async function getSectionFolderDataList({ component, current, pageSize }) {
  let datasourceUrl = component.props.viewConfig.groupList[0].datasourceUrl;

  //datasourceUrl 不为null时调用 datasourceUrl
  let searchParameter = '';
  if (component.props.searchParameter != undefined) {
    for (let key in component.props.searchParameter) {
      searchParameter += '&' + key + '=' + globalFunction.nullToEmpty(component.props.searchParameter[key]);
    }
  }
  let url = datasourceUrl !== null ? datasourceUrl + '?current=1' + searchParameter :
    component.props.areaName + '/' + component.props.section.name + '/GetFolderList?current=1' + searchParameter;

  httpClient
    .get(url)
    .then(({ data }) => {
      // console.log(component.props.areaName + '/' + component.props.section.name + ' Folder列表数据', data);
      //运行预先配置的处理data函数
      operationalFunction({ functionName: component.props.viewConfig.onLoadData, sectionName: component.props.section.name, parameter: data.data, sectionComponent: component, pageComponent: component.props.pageComponent });

      if (data.result && component !== null) {
        component.setState({
          data: []
        });
        component.setState({
          data: data.data,
          pagination: false,
          loaded: true
        });
        if (data.data.length > 0) {
          component.props.sectionComponent.setState({ showBottomButton: true });
        } else {
          component.props.sectionComponent.setState({ showBottomButton: false });
        }
        let sectionData = component.props.pageComponent.state.sectionData;
        sectionData[component.props.section.name] = data.data;
        component.props.pageComponent.setState({ sectionData });
      } else {
        message.error(data.message);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, component.props.pageComponent);
    });
}
